<template>
    <div>
        <h3>Oh, one more thing...</h3>
        <p>Wouldn't it be nice if you could publish it somewhere? Like somewhere in the cloud?</p>

        <h3>Create an <i>AWS account</i></h3>
        <p>Creating an account is free. You will also be able to try many of their features for free for one year as a part of their <i>free tier</i>.</p>
        <p>Wait no further, <a href="https://console.aws.amazon.com/" target="_blank">create your AWS account</a> today!</p>
        <p>Please be sure to monitor that you keep your usage within the <a href="https://aws.amazon.com/free/" target="_blank">Free Tier</a>.</p>
        <p>As a security best-practice; you should not use the root account. Create a new user using <i>IAM</i> with full permissions. Also, be sure to add <i>two-factor</i> authentication to <b>both</b> users.</p>
    </div>
</template>

<script>
export default {
    name: 'AwsAccount'
}
</script>